/**
 * Field label is the catalog prop. Documents saved before that change stored
 * the same text on `label` (catalog name "Field name"). Prefer fieldLabel.
 */
export const resolveMultiSelectFieldLabel = (
  fieldLabel: unknown,
  legacyLabel: unknown,
): string => {
  const primary = typeof fieldLabel === 'string' ? fieldLabel.trim() : '';
  if (primary.length > 0) return primary;
  return typeof legacyLabel === 'string' ? legacyLabel.trim() : '';
};

/**
 * Copies a saved `label` onto `fieldLabel` before the canvas drops unknown
 * props. Leaves an authored fieldLabel untouched.
 */
export const withLegacyMultiSelectLabel = (
  props: Record<string, unknown>,
): Record<string, unknown> => {
  const resolved = resolveMultiSelectFieldLabel(props.fieldLabel, props.label);
  if (resolved.length === 0) return props;
  if (props.fieldLabel === resolved) return props;
  return { ...props, fieldLabel: resolved };
};
